export const START = 'start';
export const END = 'end';
export const AUTO = 'auto';
